import { render, staticRenderFns } from "./StatisticsYear.vue?vue&type=template&id=113955b4&scoped=true&"
import script from "./StatisticsYear.vue?vue&type=script&lang=js&"
export * from "./StatisticsYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113955b4",
  null
  
)

export default component.exports